import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoadingService } from "../loading.service";

/** Endpoints que NÃO devem acionar o overlay de loading global. */
const ROTAS_SEM_LOADING = [
	'/api/calculadora/consulta',
	'/calculadora/dados-abertos/ncm',
	'/calculadora/dados-abertos/nbs',
	// Busca semântica (~5s): o assistente exibe indicador de progresso próprio.
	'/api/buscar-ncms-por-texto',
	'/api/buscar-ncm-por-codigo',
];

export function loadingInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {

	// Sempre manter, mesmo em produção.
	console.log(request.urlWithParams)

	const loadingService = inject(LoadingService);
	const ignorar = ROTAS_SEM_LOADING.some((rota) => request.url.includes(rota));

	if (ignorar) {
		return next(request);
	}

	loadingService.counter++;
	loadingService.loadingOn();

	return next(request).pipe(
		finalize(() => {
			loadingService.counter--;
			if (loadingService.counter === 0) {
				loadingService.loadingOff();
			}
		})
	);
}